// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Indie+Flower);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Oswald);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container
{
  font-family: "Indie Flower", "sans-serif";
  width: 40%;
  padding: 1em;
  margin: 0 auto;
  margin-top: 1em;
  box-shadow: 0 0 15px grey;
  
  background: white;
  border-radius: 5px;
  min-width: 270px;
  max-height: 550px;
  overflow-y: auto;
}

.drawing{
  font-family: monospace, Arial, Helvetica, sans-serif;
  position: relative;
  text-align: left;
  margin: 0 auto;
  width: -moz-fit-content;
  width: fit-content;
}

#innerContainer
{
  padding: 0 2em 2em 2em;
  text-align: center;
}

.incorrect{
  color:#d2322d;
}

.Btn
{
  font-family: "Oswald";
  padding: 10px;
  border: 2px solid lightgrey;
  border-radius: 5px;
}

.hide{
    display: none;
}

.visibility-hidden{
  visibility: hidden;
}

#hidden-input{
  visibility: hidden;
  height: 1px;
}

#keyboard-message-btn{
  margin: 0 auto;
  display: block;
}

.customSmallerBtn{
  padding: 4px;
  margin-top: 10px;
  font-size: 10px;
  
}
@media (max-width: 500px){
  h1{
    font-size: 1.2em;
  }
}

@media (max-width: 350px){
  h1{
    font-size: 1.1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAGA;;EAEE,yCAAyC;EACzC,UAAU;EACV,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;;EAEzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;;AAEjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@import url(//fonts.googleapis.com/css?family=Indie+Flower);\n@import url(//fonts.googleapis.com/css?family=Oswald);\n\n#container\n{\n  font-family: \"Indie Flower\", \"sans-serif\";\n  width: 40%;\n  padding: 1em;\n  margin: 0 auto;\n  margin-top: 1em;\n  box-shadow: 0 0 15px grey;\n  \n  background: white;\n  border-radius: 5px;\n  min-width: 270px;\n  max-height: 550px;\n  overflow-y: auto;\n}\n\n.drawing{\n  font-family: monospace, Arial, Helvetica, sans-serif;\n  position: relative;\n  text-align: left;\n  margin: 0 auto;\n  width: fit-content;\n}\n\n#innerContainer\n{\n  padding: 0 2em 2em 2em;\n  text-align: center;\n}\n\n.incorrect{\n  color:#d2322d;\n}\n\n.Btn\n{\n  font-family: \"Oswald\";\n  padding: 10px;\n  border: 2px solid lightgrey;\n  border-radius: 5px;\n}\n\n.hide{\n    display: none;\n}\n\n.visibility-hidden{\n  visibility: hidden;\n}\n\n#hidden-input{\n  visibility: hidden;\n  height: 1px;\n}\n\n#keyboard-message-btn{\n  margin: 0 auto;\n  display: block;\n}\n\n.customSmallerBtn{\n  padding: 4px;\n  margin-top: 10px;\n  font-size: 10px;\n  \n}\n@media (max-width: 500px){\n  h1{\n    font-size: 1.2em;\n  }\n}\n\n@media (max-width: 350px){\n  h1{\n    font-size: 1.1em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
